const QUIZ_ROUTE = '/pages/takethemigrainesupportquiz';
const QUIZ_TEMPLATE_VIEW = 'migraine-support-quiz';
const ATTRIBUTION_PARAMETERS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'snowball',
];
let editorPreviewMode = false;
let editorRerenderBound = false;

function preserveQuizAttribution(forceNativeView = false) {
  const source = new URLSearchParams(window.location.search);
  const previewThemeId = source.get('preview_theme_id');
  const hasPreviewThemeId = /^\d+$/.test(previewThemeId ?? '');
  const isThemePreview = hasPreviewThemeId || forceNativeView;
  const links = document.querySelectorAll('a[href]');

  for (const link of links) {
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin || destination.pathname !== QUIZ_ROUTE)
      continue;

    if (hasPreviewThemeId) {
      destination.searchParams.set('preview_theme_id', previewThemeId);
    }
    if (isThemePreview) {
      destination.searchParams.set('view', QUIZ_TEMPLATE_VIEW);
    }

    for (const parameter of ATTRIBUTION_PARAMETERS) {
      destination.searchParams.delete(parameter);
      for (const value of source.getAll(parameter)) {
        destination.searchParams.append(parameter, value);
      }
    }

    link.href = `${destination.pathname}${destination.search}${destination.hash}`;
  }
}

function bindAnnouncementEditorRerender() {
  if (editorRerenderBound) return;

  editorRerenderBound = true;
  document.addEventListener('shopify:section:load', () => {
    preserveQuizAttribution(editorPreviewMode);
  });
}

class BrQuizStickyTab extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';
    this.dataset.enhanced = 'true';

    editorPreviewMode = this.dataset.quizPreviewMode === 'true';
    preserveQuizAttribution(editorPreviewMode);
    bindAnnouncementEditorRerender();

    const storageKey = this.dataset.storageKey;
    const dismiss = this.querySelector('[data-br-quiz-tab-dismiss]');

    try {
      if (storageKey && window.sessionStorage.getItem(storageKey) === 'true') {
        this.hidden = true;
      }
    } catch {
      // Storage can be unavailable in restrictive privacy modes; the tab still works.
    }

    dismiss?.addEventListener('click', () => {
      // Take focus off the tab before hiding it, so it is never stranded on
      // a hidden control. Left there, focus would fall to <body>: nothing is
      // announced and, in some browsers, the next Tab restarts from the top
      // of the page. So it is then handed to the dismissal line that sits
      // immediately before the tab in the markup — it is read out, and Tab
      // continues from where the tab was.
      const hadFocus = this.contains(document.activeElement);
      if (hadFocus) document.activeElement.blur();
      this.hidden = true;
      if (hadFocus) this.#moveFocusToStatus();

      try {
        if (storageKey) window.sessionStorage.setItem(storageKey, 'true');
      } catch {
        // Dismissal remains effective for this page even when storage is unavailable.
      }
    });
  }

  #moveFocusToStatus() {
    const status = this.parentElement?.querySelector('[data-br-quiz-tab-status]');
    if (!(status instanceof HTMLElement)) return;

    status.hidden = false;
    // preventScroll: the line lives at the top of the page; announcing it
    // must not move the reader's scroll position.
    status.focus({ preventScroll: true });
    status.addEventListener(
      'blur',
      () => {
        status.hidden = true;
      },
      { once: true }
    );
  }
}

if (!customElements.get('br-quiz-sticky-tab')) {
  customElements.define('br-quiz-sticky-tab', BrQuizStickyTab);
}
